export default __webpack_public_path__ + "static/media/tablet.6826b31c.png";